import { CircularLoader } from '@modules/common/components/CircularLoader';
import { MetadataFieldMappingFeedbackMatchCount } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/MetadataFieldMappingList/MetadataFieldMappingFeedbackMatchCount';
import { MetadataFieldMappingUserMatchCount } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/MetadataFieldMappingList/MetadataFieldMappingUserMatchCount';
import { LinkRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { EqlField, ObjectType } from 'generated/graphql';

interface MetadataFieldMappingLinkIconProps {
  sourceEqlField: EqlField | undefined;
  targetEqlField: EqlField | undefined;
  isLoading: boolean;
  isLinked: boolean;
  errorMessage: string;
}

export const MetadataFieldMappingLinkIcon = ({
  sourceEqlField,
  targetEqlField,
  isLinked,
  isLoading,
  errorMessage,
}: MetadataFieldMappingLinkIconProps) => {
  if (isLoading) {
    return <CircularLoader size={24} />;
  }

  if (errorMessage) {
    return (
      <Stack spacing={0.5} alignItems="center" justifyContent="center">
        <LinkRounded
          sx={{
            color: 'error.light',
            fontSize: '1.8rem',
          }}
        />
        <Typography
          variant="caption"
          width="100%"
          textAlign="center"
          lineHeight="0.9rem"
          color="error.light"
        >
          {errorMessage}
        </Typography>
      </Stack>
    );
  }

  if (!isLinked) {
    return (
      <LinkRounded
        sx={{
          color: 'text.disabled',
          fontSize: '1.8rem',
        }}
      />
    );
  }

  const renderLinkMatchCount = () => {
    if (!sourceEqlField || !targetEqlField) {
      return null;
    }

    if (
      sourceEqlField.objectType === ObjectType.Feedback ||
      targetEqlField.objectType === ObjectType.Feedback
    ) {
      return (
        <MetadataFieldMappingFeedbackMatchCount
          sourceEqlField={sourceEqlField}
          targetEqlField={targetEqlField}
        />
      );
    }

    if (
      sourceEqlField.objectType === ObjectType.User ||
      targetEqlField.objectType === ObjectType.User
    ) {
      return (
        <MetadataFieldMappingUserMatchCount
          sourceEqlField={sourceEqlField}
          targetEqlField={targetEqlField}
        />
      );
    }

    return null;
  };

  return (
    <Stack spacing={0.5} alignItems="center" justifyContent="center">
      <LinkRounded
        sx={{
          color: 'success.light',
          fontSize: '1.8rem',
        }}
      />
      {renderLinkMatchCount()}
    </Stack>
  );
};
